import { ReviewViewModel } from "../../api/apiSchema";
import {
  GET_REVIEWS_REQUEST,
  GET_REVIEWS_SUCCESS,
  GET_REVIEWS_FAILURE,
  GET_USER_REVIEWS_REQUEST,
  GET_USER_REVIEWS_SUCCESS,
  GET_USER_REVIEWS_FAILURE,
  GET_ORDER_REVIEWS_REQUEST,
  GET_ORDER_REVIEWS_SUCCESS,
  GET_ORDER_REVIEWS_FAILURE,
  CREATE_REVIEW_REQUEST,
  CREATE_REVIEW_SUCCESS,
  CREATE_REVIEW_FAILURE,
  SUBMIT_REVIEW_REQUEST,
  SUBMIT_REVIEW_SUCCESS,
  SUBMIT_REVIEW_FAILURE,
} from "../../../pages/Reviews/actions";

export interface ReviewState {
  reviews: ReviewViewModel[];
  userReviews: ReviewViewModel[];
  orderReviews: ReviewViewModel[];
  loading: boolean;
  userReviewsLoading: boolean;
  orderReviewsLoading: boolean;
  createReviewLoading: boolean;
  submitReviewLoading: boolean;
  error: string | null;
  userReviewsError: string | null;
  orderReviewsError: string | null;
  createReviewError: string | null;
  submitReviewError: string | null;
  totalCount: number;
  userReviewsTotalCount: number;
  orderReviewsTotalCount: number;
  currentPage: number;
}

const initialState: ReviewState = {
  reviews: [],
  userReviews: [],
  orderReviews: [],
  loading: false,
  userReviewsLoading: false,
  orderReviewsLoading: false,
  createReviewLoading: false,
  submitReviewLoading: false,
  error: null,
  userReviewsError: null,
  orderReviewsError: null,
  createReviewError: null,
  submitReviewError: null,
  totalCount: 0,
  userReviewsTotalCount: 0,
  orderReviewsTotalCount: 0,
  currentPage: 1,
};

export default function reviewReducer(state = initialState, action: any): ReviewState {
  switch (action.type) {
    case GET_REVIEWS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_REVIEWS_SUCCESS:
      return {
        ...state,
        loading: false,
        reviews: action.payload.reviews || [],
        totalCount: action.payload.totalCount || 0,
      };
    case GET_REVIEWS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case GET_USER_REVIEWS_REQUEST:
      return {
        ...state,
        userReviewsLoading: true,
        userReviewsError: null,
      };
    case GET_USER_REVIEWS_SUCCESS:
      return {
        ...state,
        userReviewsLoading: false,
        userReviews: action.payload.reviews || [],
        userReviewsTotalCount: action.payload.totalCount || 0,
      };
    case GET_USER_REVIEWS_FAILURE:
      return {
        ...state,
        userReviewsLoading: false,
        userReviewsError: action.payload,
      };

    case GET_ORDER_REVIEWS_REQUEST:
      return {
        ...state,
        orderReviewsLoading: true,
        orderReviewsError: null,
      };
    case GET_ORDER_REVIEWS_SUCCESS:
      return {
        ...state,
        orderReviewsLoading: false,
        orderReviews: action.payload.reviews || [],
        orderReviewsTotalCount: action.payload.totalCount || 0,
      };
    case GET_ORDER_REVIEWS_FAILURE:
      return {
        ...state,
        orderReviewsLoading: false,
        orderReviewsError: action.payload,
      };

    case CREATE_REVIEW_REQUEST:
      return {
        ...state,
        createReviewLoading: true,
        createReviewError: null,
      };
    case CREATE_REVIEW_SUCCESS:
      return {
        ...state,
        createReviewLoading: false,
      };
    case CREATE_REVIEW_FAILURE:
      return {
        ...state,
        createReviewLoading: false,
        createReviewError: action.payload,
      };

    case SUBMIT_REVIEW_REQUEST:
      return {
        ...state,
        submitReviewLoading: true,
        submitReviewError: null,
      };
    case SUBMIT_REVIEW_SUCCESS:
      return {
        ...state,
        submitReviewLoading: false,
      };
    case SUBMIT_REVIEW_FAILURE:
      return {
        ...state,
        submitReviewLoading: false,
        submitReviewError: action.payload,
      };

    default:
      return state;
  }
} 